import {gql} from '@apollo/client';

/**
 * Contact correspondence need (DBO-80): Curo's `t4a_specialcarerequirement`
 * picklist on the contact, edited from the account overview and written to
 * Curo in the same request. The fragment is what the grid shows and what the
 * mutation returns, so Apollo updates the row from the mutation result.
 */
export const CORRESPONDENCE_NEED_CONTACT_FRAGMENT = gql`
  fragment CorrespondenceNeedContact on ContactType {
    id
    specialCareRequirement
    specialCareApplies
  }
`;

export const GET_CORRESPONDENCE_NEED_OPTIONS = gql`
  query CorrespondenceNeedOptions {
    correspondenceNeedOptions {
      isEnabled
      options
    }
  }
`;

export const GET_CONTACT_CORRESPONDENCE_NEEDS = gql`
  query ContactCorrespondenceNeeds($accountId: UUID!) {
    contacts(accountId: $accountId) {
      ...CorrespondenceNeedContact
    }
  }
  ${CORRESPONDENCE_NEED_CONTACT_FRAGMENT}
`;

export const UPDATE_CORRESPONDENCE_NEED = gql`
  mutation UpdateCorrespondenceNeed(
    $contactId: UUID!
    $accountId: UUID!
    $correspondenceNeed: String
  ) {
    updateCorrespondenceNeed(
      contactId: $contactId
      accountId: $accountId
      correspondenceNeed: $correspondenceNeed
    ) {
      ok
      errors
      contact {
        ...CorrespondenceNeedContact
      }
    }
  }
  ${CORRESPONDENCE_NEED_CONTACT_FRAGMENT}
`;
